import React from 'react'

import style from './Tabs.module.scss'

import Label from './Label'

const Labels = ({
  state,
  onSelection
}) => (
  <div className={style.labels}>
    { state && state.labels.map((label, index) => 
      <Label 
        label={label} 
        key={index} 
        selected={state && state.selected === label}
        onSelection={onSelection} />
    )}
  </div>
)

export default Labels